







































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { InstallationWizardApi } from '../api/installationWizard';
import { Action, State } from 'vuex-class';
import { AuthStateInterface } from 'modules/auth/interfaces/authState';
import { LoginCredentials } from 'modules/auth/interfaces/loginCredentials';
import { ApiResponse } from 'modules/auth/interfaces/apiResponse';
import Register from './Register.vue';
import Login from './Login.vue';
import WizardSummary from './WizardSummary.vue';
import ApiKeys from './ApiKeys.vue';
import { Integrations } from '../enums/integrations';
import { Integration } from '../classes/integration';
import { WizardQueryParams } from '../classes/wizardQueryParams';
import { AccountData } from '../classes/accountData';
import { ContactProperty } from '../classes/contactProperty';
import AppMessage from '../../core/models/appMessage';
import { SyncStatus } from '../enums/syncStatus';
import { Creator } from '../classes/creator';
import { PropertiesApi } from 'modules/properties/api/properties';
import { AppResponse } from '@/modules/core/interfaces/appResponse';
import { IntegrationApiKeys } from '../classes/integrationApiKeys';
import { ProfileApi } from '@/modules/profile/api/profile';
import { ProfileModel } from '@/modules/profile/classes/profile';

@Component({
  components: {
    Register,
    Login,
    WizardSummary,
    ApiKeys,
  },
})
export default class Wizard extends Vue {
  public loading: boolean = false;
  public customColor: string = '#0A99E0';
  public currentStep: number = 1;
  public steps: string[] = [];
  public currentStepName: string = '';
  public integration!: Integration;
  public loginData!: AccountData;
  public accountExist: boolean = false;
  public slideDirection: string = 'slideNext';
  public nextStepButtonLoading: boolean = false;
  public redirectUrl: string = '';
  public isUserLogin: boolean = false;
  private api: InstallationWizardApi;
  private profileApi: ProfileApi;

  private accountStep: string = 'account';
  private apiKeysStep: string = 'apikeys';
  private summaryStep: string = 'summary';

  public initData!: WizardQueryParams;

  @Action('auth/setAccessToken') private setAccessToken!: (
    token: string,
  ) => void;

  @Action('auth/login') private login!: (
    data: LoginCredentials,
  ) => Promise<ApiResponse>;

  @Action('auth/setUserLanguage') private setUserLanguage!: (
    token: string,
  ) => void;

  constructor() {
    super();
    this.api = new InstallationWizardApi();
    this.profileApi = new ProfileApi();
  }

  public async created() {
    this.loading = true;

    const initData: WizardQueryParams = new WizardQueryParams(
      this.$route.query,
    );
    this.initData = initData;

    if(initData.lang) {
      this.$i18n.locale = initData.lang;
    }

    this.integration = new Integration({
      type: initData.type,
      callback: initData.callback,
      accountData: {
        name: initData.name,
        phone: initData.phone,
        email: initData.email,
        lang: initData.lang,
        domain: initData.domain,
        props: [],
      },
    });

    this.setUserLanguage(this.integration.accountData.lang);

    this.loadSteps();

    if(this.integration.type == 'shoper')
    {
      this.configureShoperApiKeys();
    }

    this.loginData = new AccountData({
      email: initData.email,
    });

    if (this.integration.accountData.domain) {
      await this.checkIfIntegrationExistsByDomainAndType();
    } else if (this.integration.accountData.email) {
      await this.checkIfUserHasIntegration();
    }

    if (await this.checkIfUserIsLogin() === false) {
      await this.getCreatorAccountInfo();

      await this.createCreator();
    } else {
      var profile = await this.profileApi.getProfile();
      this.$i18n.locale = profile.language
      return;
    }

    this.loading = false;
  }

  public loadSteps() {
    const steps = [];
    steps.push(this.accountStep);
    if (this.canShowApiKeysStep()) {
      steps.push(this.apiKeysStep);
    }
    steps.push(this.summaryStep);

    this.steps = steps;
    this.currentStepName = this.accountStep;
    this.updateCurrentStepNumber();
  }

  public updateAccountData(data: AccountData) {
    this.integration.accountData.email = data.email;
  }

  public updatePropsData(data: ContactProperty[]) {
    this.integration.accountData.props = data.map((item: ContactProperty) => {
      item.origin = this.integration.type;
      return item;
    });
  }

  public updateApiKeys(apiKeys: IntegrationApiKeys) {
    this.integration.apiKeys = apiKeys;
  }

  public goToLogin() {
    this.accountExist = true;
    (this.$refs.login as Login).refershLanguage();
  }

  public goToRegister() {
    this.accountExist = false;
  }

  public async prevStep() {
    this.slideDirection = 'slidePrev';
    this.loading = true;
    if(this.currentStepName == this.apiKeysStep)
    {
      await this.onApiKeyPreviousStep();
    }
  
    this.loading = false;
  }

  public async nextStep() {
    this.slideDirection = 'slideNext';
    this.loading = true;
    this.nextStepButtonLoading = true;

    if (this.currentStepName === this.accountStep) {
      await this.onAccountNextStep();
    } else if (this.currentStepName === this.apiKeysStep) {
      await this.onApiKeysStep();
    }

    this.nextStepButtonLoading = false;
    this.loading = false;
  }

  public async onAccountNextStep() {
      if (this.isUserLogin) {
        await this.showNextStep();
        return;
      }

      if (this.accountExist) {
        if (await this.loginAccount()) {
          await this.showNextStep();
          return;
        }
      } else {
        if (await this.createAccount()) {
          await this.showNextStep();
          return;
        }
      }
  }

  public async onApiKeysStep() {
    const isValid = await (this.$refs.apiKeys as ApiKeys).validateForm();

    if (isValid === false) {
      return false;
    }
    var validationResult = await this.api.ValidateApiKey(this.integration.apiKeys.apiKey, this.integration.type);
    if(validationResult === false)
    {
      AppMessage.show(this.$t('wizard.apikeys.invalidApiKey'), 'error');
      return false;
    }
    await this.toSummaryStep();
  }

  public async onApiKeyPreviousStep(){
        await this.showAccountStep();
  }

  public async onSummaryPreviousStep()
  {
    if(this.canShowApiKeysStep())
    {
      await this.showApiKeysStep();
    }
    else{
      await this.showAccountStep();
    }
  }

  public async showNextStep() {
    if (this.currentStepName === this.accountStep) {
      if (this.canShowApiKeysStep()) {
        await this.showApiKeysStep();
      } else {
        await this.toSummaryStep();
        await this.showSummaryStep();
      }
    } else if (this.currentStepName === this.apiKeysStep) {
      await this.showSummaryStep();
    }
  }

  public async showAccountStep()
  {
    this.currentStepName = this.accountStep;
    this.updateCurrentStepNumber();
  }

  public async showApiKeysStep() {
    this.currentStepName = this.apiKeysStep;
    this.updateCurrentStepNumber();
  }

  public async showSummaryStep() {
    this.currentStepName = this.summaryStep;
    this.updateCurrentStepNumber();
    this.$router.push("/install-summary");
  }

  public updateCurrentStepNumber() {
    this.currentStep = this.steps.indexOf(this.currentStepName) + 1;
  }

  public async toSummaryStep() {
    if (await this.ConfigureIntegration() === true) {
      try {
        this.api.integrationCallback(this.integration.callback!, null);
      } catch ( error ) {
        console.error('callback error:' + error);
      }

      if (this.redirectUrl === '') {
        this.showNextStep();
      } else {
        window.location.href = this.redirectUrl;
      }
    }
  }

  public async GetUserProfile() : Promise<ProfileModel | null>
  {
    try{
      var profile = await this.profileApi.getProfile();
      return profile;
    }catch(error)
    {
      return null;
    }
  }
  public async loginAccount() {
    const isValid = await (this.$refs.login as Login).validateForm();

    if (isValid === false) {
      return false;
    }

    try {
      const apiResponse = await this.login({
        username: this.loginData.email,
        password: this.loginData.password,
      });

      this.isUserLogin = true;
      return true;
    } catch (error) {
      AppMessage.show(this.$t('forms.invalidUserNameOrPassword'), 'error');
    }

    return false;
  }

  public async createAccount() {
    const isValid = await (this.$refs.register as Register).validateForm();

    if (isValid === false) {
      return false;
    }

    try {
      const response = await this.api.createAccount(this.integration.type, this.integration.accountData);
      if (response != null) {
        if (response.accessToken) {
          this.setAccessToken(response.accessToken);
          this.isUserLogin = true;
        }
      }
      return true;
    } catch (error) {
      this.showErrors(error, this.$t('wizard.createIntegrationError'));
    }

    return false;
  }

  public async createCreator() {
    if (this.integration.accountData.email == null || this.integration.accountData.email.length === 0) {
      return;
    }
    const creator = new Creator({
      name: this.integration.accountData.name,
      email: this.integration.accountData.email,
      domain: this.integration.accountData.domain,
      integration: this.integration.type,
    });
    const response = await this.api.createCreator(creator);
    return true;
  }

  public endSetup() {
    this.$router.push('/login');
  }

  public async checkIfUserHasIntegration() {
    try {
      const response = await this.api.checkIfIntegrationExists(
        this.integration.accountData.email,
        this.integration.type,
      );
      if (response !== undefined) {
        if (response) {
          return;
        }
      } else {
        this.$router.push('/login');
      }
    } catch (error) {
      this.$router.push('/login');
    }
  }

  public async checkIfIntegrationExistsByDomainAndType() {
    try {
      const response = await this.api.checkIfIntegrationExistsByDomainAndType(
        this.integration.accountData.domain!,
        this.integration.type,
      );
      if (response !== undefined) {
        if (response) {
          return;
        }
      } else {
        this.$router.push('/login');
      }
    } catch (error) {
      this.$router.push('/login');
    }
  }

  public async checkIfUserIsLogin() {
    if (await this.api.checkIfUserIsLogin()) {
      this.isUserLogin = true;
      await this.nextStep();
      return true;
    }

    return false;
  }

    public async ConfigureIntegration() {
    try {
      const result = await this.api.configureIntegration({
        domain: this.integration.accountData.domain,
        integration: this.integration.type,
        apiKeys: this.integration.apiKeys,
      });

      if (result.Result.redirectUrl) {
        this.redirectUrl = result.Result.redirectUrl;
      }

      return result.IsSuccess;
    } catch (error) {
      return false;
    }
  }

  public async getCreatorAccountInfo() {
    try {
      if (this.integration.accountData.email == null || this.integration.accountData.email.length === 0) {
        return;
      }

      const response = await this.api.getCreatorAccountInfo(this.integration.accountData.email);
      if (response) {
        if (response.email && !this.integration.accountData.email) {
          this.integration.accountData.email = response.email;
        }

        if (response.lcAccountExist) {
          this.accountExist = true;
        }
      }
    } catch (error) {
      this.integration.accountData.email = '';
    }
  }

  private showErrors(error: Error, defaultError: any) {
    if (error.message) {
      const errorMsgs = [];

      for (const errorCode of error.message.split(',')) {
        errorMsgs.push(this.$t(`backend.errors.${errorCode}`));
      }

      AppMessage.show(errorMsgs.join('<br>'), 'error');
    } else {
      if (defaultError != null) {
        AppMessage.show(defaultError, 'error');
      }
    }
  }

  private configureShoperApiKeys()
  {
    this.integration.apiKeys = new IntegrationApiKeys();
    this.integration.apiKeys.clientId = this.initData.clientId as string;
    this.integration.apiKeys.timestamp = this.initData.timestamp as string;
    this.integration.apiKeys.place = this.initData.place as string;
    this.integration.apiKeys.hash = this.initData.hash as string;
  }

  private canShowApiKeysStep(): boolean {
    if (this.integration.type === Integrations.BASELINKER) {
      return true;
    }

    if (this.integration.type === Integrations.PRESTASHOP) {
      return true;
    }
    if (this.integration.type === Integrations.ERECRUITER) {
      return true;
    }
    if (this.integration.type === Integrations.APILO) {
      return true;
    }
    return false;
  }

  get ShowPreviousButton() : boolean {
    if(this.currentStepName === this.accountStep || this.currentStepName === this.apiKeysStep)
    {
      return false;
    }
    if(this.currentStepName === this.summaryStep && !this.canShowApiKeysStep())
    {
    return false;
    }
    return true;
  }

}
